
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/track-application",
      function () {
        return require("private-next-pages/track-application.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/track-application"])
      });
    }
  